const contractAddresses = require("./contractAddresses.json")
const eventTopics = require("./eventTopics.json")
const positionsNumber = require("./positionsNumber.json")
const layoutNumber = require("./layoutsNumber.json")
const layoutsPositions = require("./layoutsPositions.json")
const abi_KickToken = require("./abi_KickToken.json")
const abi_PlayerLoan = require("./abi_PlayerLoan.json")
const abi_PlayerTransfer = require("./abi_PlayerTransfer.json")
const abi_VerifiableRandomFootballer = require("./abi_VerifiableRandomFootballer.json")
const abi_LeagueTeam = require("./abi_LeagueTeam.json")
const abi_LeagueGame = require("./abi_LeagueGame.json")
const abi_PlayerRate = require("./abi_PlayerRate.json")
const abi_GameResult = require("./abi_GameResult.json")
const abi_ClaimKickToken = require("./abi_ClaimKickToken.json")
const abi_event_challengeDeclined = require("./abi_event_challengeDeclined.json")
const abi_event_teamChallenged = require("./abi_event_teamChallenged.json")
const abi_event_gameFinished = require("./abi_event_gameFinished.json")

module.exports = {
    contractAddresses,
    eventTopics,
    positionsNumber,
    layoutNumber,
    layoutsPositions,
    abi_KickToken,
    abi_PlayerLoan,
    abi_PlayerTransfer,
    abi_VerifiableRandomFootballer,
    abi_LeagueTeam,
    abi_LeagueGame,
    abi_PlayerRate,
    abi_GameResult,
    abi_ClaimKickToken,
    abi_event_challengeDeclined,
    abi_event_teamChallenged,
    abi_event_gameFinished
}